import styled from "styled-components";

export const StructuredTextContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;
